import md5 from "md5";
import EncUtf8 from "crypto-js/enc-utf8";
import AES from "crypto-js/aes";
import modECB from "crypto-js/mode-ecb";
import pkcs7 from "crypto-js/pad-pkcs7";
import { Buffer } from "buffer";

import { validatePhone, validateHkPhone } from "./validator";
import CryptoJS from "crypto-js";
import isArray from "lodash/isArray";
const timestamp = new Date().getTime(); // 当前时间戳
import { loadEnv } from "@build/index";
const { VITE_RANDOM } = loadEnv();

/**
 *
 * @param {md5加密}
 */
const signmd5 = function (obj: Record<string, any>) {
  const md5StrRandom = VITE_RANDOM;
  let arr = [];
  const result = obj;
  arr = Object.keys(obj);
  arr = arr.sort();
  let str = "";
  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i] === "sign") {
      str += "";
    } else {
      let val = obj[arr[i]];
      if (typeof val == "object") {
        val = JSON.stringify(val);
      }
      if (val || typeof val == "number") {
        str += `&${arr[i]}=${val}`;
      }
    }
  }
  str = str.substring(1);
  result.sign = md5(`${str}${md5StrRandom}`).toLowerCase();
  return result;
};

/**
 *
 * @param {*生成随机串的长度} len
 */
const nonceStr = (len = 32): string => {
  const $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const maxPos = $chars.length;
  let pwd = "";
  for (let i = 0; i < len; i += 1) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

const stringtoHex = str => {
  let val = "";
  for (let i = 0; i < str.length; i++) {
    if (val == "") {
      val = str.charCodeAt(i).toString();
    } else {
      val += str.charCodeAt(i).toString();
    }
    val += "0a";
    return val;
  }
};
/**
 *
 * @param {AES 解密}
 */
const decrypt = (word, initKey): string => {
  const keys = EncUtf8.parse(initKey);
  const words = Buffer.from(word, "hex").toString("base64");
  // const words = stringtoHex(word).toString("base64");
  const decrypt = AES.decrypt(words, keys, {
    mode: modECB,
    padding: pkcs7
  });
  const decryptedStr = decrypt.toString(EncUtf8);
  return decryptedStr.toString();
};

/**
 *
 * @param {AES 加密}
 */
const encrypt = (word, initKey) => {
  const key = CryptoJS.enc.Utf8.parse(initKey);
  const srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(word));
  const cipher = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return cipher.ciphertext.toString();
};

/**
 *
 * @param {发送短信验证码提示}
 */

const smsTip = (): string => {
  const phoneNumber = localStorage.getItem("c_mobile").substr(7);
  const SMS = `验证码成功发送至安全手机***${phoneNumber}，请注意查收手机`;
  return SMS;
};

/**
 *
 * @param {手机号前三后四}
 */

const formatTel = tel => {
  const reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, "$1****$2");
};

const cardNoStar = cardNo => {
  const bankNo = cardNo.replace(/\s+/g, "");
  const reg = /^(\d{4})\d+(\d{4})$/;
  return bankNo.replace(reg, "$1****$2");
};

/**
 *
 * @param {验证码类型}
 */

const captchaType = flag => {
  let type = "";
  switch (flag) {
    case "login":
      type = "UpdateLoginPassword";
      break;
    case "pay":
    case "payReset":
      type = "UpdatePayPassword";
      break;
    case "addAccount":
      type = "AddAccount";
      break;
    case "paySet":
      type = "AddPayPassword";
      break;
    default:
      type = "UpdateLoginPassword";
  }
  return type;
};

// 省市数据处理
function provCity(provinces) {
  const arr = JSON.parse(
    JSON.stringify(provinces)
      .replace(/provName/g, "label")
      .replace(/cityName/g, "label")
      .replace(/cities/g, "children")
  );
  const temArr = [];
  arr.forEach(outer => {
    const children = [];
    if (outer.children) {
      outer.children.forEach(inner => {
        children.push({
          label: inner.label,
          value: nonceStr()
        });
      });
    }
    const temp = {
      label: outer.label,
      value: nonceStr(),
      children: children
    };
    temArr.push(temp);
  });
  return temArr;
}

// 分支行数据转换
const bankBranch = arr => {
  const branchs = [];
  arr.forEach(item => {
    const temp = {
      label: item.branchName,
      value: item.bankLineNo
    };
    branchs.push(temp);
  });
  return branchs;
};

// 自定义选择时间
const viture = function (len, index, dateCur, timeQuantum) {
  const d = new Date();
  const end = d.toLocaleDateString("zh-CN").replace(/\//g, "-") + " 23:59:59";
  d.setMonth(d.getMonth() - len);
  const start = d.toLocaleDateString("zh-CN").replace(/\//g, "-") + " 00:00:00";
  dateCur.value = index;
  timeQuantum.value = [start, end];
};
// 获取校验最大的对象说明
const getLengthRule = function (length: number, event = "blur") {
  return { max: length, message: `不能超过${length}个字符`, trigger: event };
};
// 获取校验对象说明
const getRequiredRule = function (tipName: string, event = "blur") {
  return { required: true, message: tipName, trigger: event };
};

// 获取校验对象说明
const ruleNameValid = function (tipName, event = "blur") {
  return { required: true, validator: validNameEn, trigger: event };
};
// 根据数据对象，获取对应的值的，其他属性值
//    [{
//         "tradeCodeName": "货物贸易",
//         "tradeCode": "00"
//     },
//     {
//         "tradeCodeName": "服务贸易",
//         "tradeCode": "01"
//     }]
// getMap(arr,'00','tradeCode','tradeCodeName'); // 货物贸易
const getArrKeysVal = function (arr, val, setKey, getKey) {
  let ob = "";
  if (!isArray(arr)) {
    console.log("不是数组请检查");
    return;
  }
  arr.forEach(item => {
    if (item[setKey] === val) {
      ob = item[getKey];
    }
  });
  return ob;
};

// 切换不同区域手机验证方法
const changePhoneRule = function (val, rules) {
  console.log("change", rules);
  if (val === "852") {
    rules.mobile = {
      required: true,
      validator: validateHkPhone,
      trigger: "blur"
    };
  } else {
    rules.mobile = {
      required: true,
      validator: validatePhone,
      trigger: "blur"
    };
  }
};

const getDefaultMonth = function (): Array<string> {
  const d = new Date();
  const end = d.toLocaleDateString("zh-CN").replace(/\//g, "-") + " 23:59:59";
  d.setMonth(d.getMonth() - 1);
  const start = d.toLocaleDateString("zh-CN").replace(/\//g, "-") + " 00:00:00";
  console.log("getDefaultMonth", end, start);
  return [start, end];
};

export {
  signmd5,
  nonceStr,
  timestamp,
  decrypt,
  encrypt,
  smsTip,
  formatTel,
  captchaType,
  provCity,
  bankBranch,
  cardNoStar,
  viture,
  getLengthRule,
  getRequiredRule,
  getArrKeysVal,
  changePhoneRule,
  getDefaultMonth
};
